/**
 * Stable CSS class names for E2E — Customer menu paper (vertical tabs shell).
 */
export const CMP = {
    page: 'customer-menu-paper',
    tabsGrid: 'customer-menu-paper__tabs-grid',
} as const;

export const cmpCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
